import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const login = () => import('../components/login/login.vue')
const main =()=>import('../components/main/main')
const projectJD =()=>import('../components/projectJD/projectJD')
const xwls =()=>import('../components/xwls/xwls')
const xwls_rcjc =()=>import('../components/xwls/xwls-rcjc')
const xwls_jbnr =()=>import('../components/xwls/xwls-jbnr')
const map =()=>import('../components/xwls/map')

// export default new Router({
const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/main',
      name: 'main',
      component: main,
      children: [
        {
          path: '/main/projectJD',
          component: projectJD,
          name: 'projectJD'
        },
        {
          path: '/main/xwls',
          component: xwls,
          name: 'xwls'
        },
      ],
    },
    {
      path: '/main/xwls_rcjc/:GONGCHENG_UID/:GONGCHENG_NAME',
      component: xwls_rcjc,
      name: 'xwls_rcjc'
    },
    {
      path: '/main/xwls_jbnr/:GONGCHENG_UID/:GONGCHENG_NAME',
      component: xwls_jbnr,
      name: 'xwls_jbnr'
    },
    {
      path: '/main/map/:LOCATION',
      component: map,
      name: 'map'
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
// 跳转之后重置界面大小
// router.afterEach((to, from) => {
//   // 基准
//   const baseSize = 16
//   // 设置 rem 函数
//   function setRem() {
//     // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
//     const scale = document.documentElement.clientWidth / 1920
//     // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
//     document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
//   }
//   setRem()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js